import { render, staticRenderFns } from "./AsEmployeeQuizQuestionCard.vue?vue&type=template&id=31e77ae0&scoped=true"
import script from "./AsEmployeeQuizQuestionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AsEmployeeQuizQuestionCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsEmployeeQuizQuestionCard.vue?vue&type=style&index=0&id=31e77ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e77ae0",
  null
  
)

export default component.exports